export default __webpack_public_path__ + "static/virsat-logo-light-362612aa62dadf25a3d92d9a86be2109.svg";